import { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const PageTransition = ({ children }) => {
  const location = useLocation();
  const [phase, setPhase] = useState('idle');
  const prevPath = useRef(location.pathname);

  useEffect(() => {
    if (prevPath.current === location.pathname) return;
    const isAdmin = location.pathname.startsWith('/admin') || location.pathname.startsWith('/portal');
    prevPath.current = location.pathname;
    if (isAdmin) return;

    setPhase('cover');
    const revealTimer = setTimeout(() => setPhase('reveal'), 350);
    const doneTimer = setTimeout(() => setPhase('idle'), 700);

    return () => {
      clearTimeout(revealTimer);
      clearTimeout(doneTimer);
    };
  }, [location.pathname]);

  return (
    <>
      {phase !== 'idle' && (
        <>
          {/* Top half slides down */}
          <div
            className="fixed inset-x-0 top-0 h-1/2 z-[100] pointer-events-none"
            style={{
              background: 'linear-gradient(to bottom, #4A5D23, #6B7F3A)',
              transform: phase === 'cover' ? 'translateY(0)' : 'translateY(-100%)',
              transition: 'transform 350ms cubic-bezier(0.4, 0, 0.2, 1)',
            }}
          />
          {/* Bottom half slides up */}
          <div
            className="fixed inset-x-0 bottom-0 h-1/2 z-[100] pointer-events-none"
            style={{
              background: 'linear-gradient(to top, #4A5D23, #6B7F3A)',
              transform: phase === 'cover' ? 'translateY(0)' : 'translateY(100%)',
              transition: 'transform 350ms cubic-bezier(0.4, 0, 0.2, 1)',
            }}
          />
          {/* Logo centered */}
          <div
            className="fixed inset-0 z-[101] flex items-center justify-center pointer-events-none"
            style={{
              opacity: phase === 'cover' ? 1 : 0,
              transition: 'opacity 280ms ease',
            }}
          >
            <img
              src="/logo.png"
              alt="Eden's Dawn"
              className="h-[30rem] w-auto"
              style={{ filter: 'brightness(1.4) contrast(1.2)', mixBlendMode: 'multiply' }}
            />
          </div>
        </>
      )}
      {children}
    </>
  );
};

export default PageTransition;
